/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_BreadcrumbInputs */

const en_gc_guides_breadcrumb = /** @type {(inputs: Gc_Guides_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breadcrumb`)
};

const zh_gc_guides_breadcrumb = /** @type {(inputs: Gc_Guides_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`面包屑导航`)
};

/**
* | output |
* | --- |
* | "Breadcrumb" |
*
* @param {Gc_Guides_BreadcrumbInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_breadcrumb = /** @type {((inputs?: Gc_Guides_BreadcrumbInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_BreadcrumbInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_breadcrumb(inputs)
	return zh_gc_guides_breadcrumb(inputs)
});
export { gc_guides_breadcrumb as "gc.guides.breadcrumb" }